import { ImageSourceSizes, PlayRoundIcon, Typography, getTypographyDefaultColor } from '@ag1/ui';
import clsx from 'clsx';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import { Videostrip } from 'types/studio/studio';
import CustomPortableText from '../../PortableText/PortableText';
import { StudioBaseImageV2 } from '../../StudioBaseImage/StudioBaseImage';

import styles from './VideostripItem.module.scss';

type Props = {
  onClick: () => void;
  item: Videostrip['items'][number];
  theme: Videostrip['theme'];
  imageSizes: ImageSourceSizes;
  eagerLoading?: boolean;
};

const VideostripItem = (props: Props) => {
  const {
    onClick,
    item: { title, subtitle, coverImage },
    theme,
    imageSizes,
    eagerLoading
  } = props;

  return (
    <div className={styles.item}>
      <button type="button" className={styles.preview} onClick={onClick}>
        <StudioBaseImageV2
          image={coverImage}
          sizes={imageSizes}
          className={styles.coverImageContainer}
          eagerLoading={eagerLoading}
        />
        <div className={styles.iconButton}>
          <PlayRoundIcon />
        </div>
      </button>
      <div className={styles.info}>
        {subtitle && (
          <Typography
            variant="body"
            component="div"
            color={getTypographyDefaultColor(theme)}
            size="2"
            noPadding
            className={styles.subtitle}>
            <CustomPortableText value={subtitle} />
          </Typography>
        )}
        {subtitle && title && <div className={clsx(styles.divider, getThemeCSSClass(theme))} />}
        {title && (
          <Typography
            variant="portalCaption"
            size="1"
            component="div"
            color={getTypographyDefaultColor(theme)}
            noPadding
            className={styles.title}>
            <CustomPortableText value={title} />
          </Typography>
        )}
      </div>
    </div>
  );
};

export default VideostripItem;
